import React, { useState, useEffect, useRef } from "react";

import teacher from "../../../assets/images/teacher.webp";
import rain from "../../../assets/images/rain.svg";
import heart from "../../../assets/images/heart.svg";
import mendal_start from "../../../assets/images/medal_star.svg";
import check1 from "../../../assets/images/check1.svg";

export default function PartnerBody() {
  const [percentage1, setPercentage1] = useState(0);
  const [percentage2, setPercentage2] = useState(0);
  const [percentage3, setPercentage3] = useState(0);
  const [percentage4, setPercentage4] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);
  const containerRef = useRef(null);

  const startCounting = () => {
    if (hasAnimated) return; // Don't restart if already animated

    const duration = 1000;
    const totalSteps = 50;
    const interval = duration / totalSteps;

    const timer = setInterval(() => {
      setPercentage1((prev) => {
        const next = Math.min(prev + Math.ceil(25 / totalSteps), 25);
        return Math.floor(next);
      });

      setPercentage2((prev) => {
        const next = Math.min(prev + Math.ceil(80 / totalSteps), 80);
        return Math.floor(next);
      });

      setPercentage3((prev) => {
        const next = Math.min(prev + Math.ceil(99 / totalSteps), 99);
        return Math.floor(next);
      });

      setPercentage4((prev) => {
        const next = Math.min(prev + Math.ceil(100 / totalSteps), 100);
        return Math.floor(next);
      });
    }, interval);

    setTimeout(() => {
      clearInterval(timer);
      setPercentage1(25);
      setPercentage2(80);
      setPercentage3(99);
      setPercentage4(100);
      setHasAnimated(true); // Mark as animated
    }, duration);

    return () => clearInterval(timer);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasAnimated) {
          startCounting();
        }
      },
      { threshold: 0.2 }
    );
    if (containerRef.current) observer.observe(containerRef.current);
    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, [hasAnimated]);

  return (
    <div
      ref={containerRef}
      className="container mx-auto p-3 flex flex-col items-center justify-center md:flex-row md:w-full lg:grid-cols-2 gap-4 w-full"
    >
      <div className="grid grid-cols-2 w-full items-center justify-center gap-[1rem] container flex-1 ">
        <div className="shadow-custom rounded-[20px] bg-white border border-solid border-[#E2E2E2]   w-full h-[14.875rem] lg:h-[16.25rem] gap-4 flex flex-col  justify-start p-2">
          <img src={rain} alt="check1" className=" h-[2.25rem]  lg:h-[104px]" />
          <p className=" font-semibold text-[1.75rem] lg:text-[2.875rem] lg:text-left">
            {percentage1}+
          </p>
          <p className=" text-[1rem] font-normal  lg:text-[1.125rem] relative lg:bottom-4">
            Năm kinh nghiệm trong lĩnh vực IT
          </p>
        </div>
        <div className="shadow-custom rounded-[20px] bg-white border border-solid border-[#E2E2E2]   w-full h-[14.875rem] lg:h-[16.25rem] gap-4 flex flex-col  justify-start p-2">
          <img
            src={check1}
            alt="check1"
            className=" lg:h-[104px] h-[2.25rem]"
          />
          <p className=" font-semibold text-[1.75rem] lg:text-[2.875rem] lg:text-left">
            {percentage2}+
          </p>
          <p className=" text-[1rem] font-normal  lg:text-[1.125rem] relative lg:bottom-4">
            Câu chuyện thành công của đối tác
          </p>
        </div>

        <div className="shadow-custom rounded-[20px] bg-white border border-solid border-[#E2E2E2]   w-full h-[14.875rem] lg:h-[16.25rem] gap-4 flex flex-col  justify-start p-2">
          <img
            src={heart}
            alt="check1"
            className=" h-[2.25rem]  lg:h-[104px]"
          />
          <p className=" font-semibold text-[1.75rem] lg:text-[2.875rem] lg:text-left">
            {percentage3}%
          </p>
          <p className=" text-[1rem] font-normal  lg:text-[1.125rem]">
            Sự tin tưởng của khách hàng
          </p>
        </div>
        <div className="shadow-custom rounded-[20px] bg-white border border-solid border-[#E2E2E2]   w-full h-[14.875rem] lg:h-[16.25rem] gap-4 flex flex-col  justify-start p-2">
          <div className="lg:flex lg:items-center lg:justify-center items-center flex justify-center">
            <img
              src={mendal_start}
              alt="check1"
              className="w-[2.25rem] h-[2.25rem] lg:w-[104px] lg:h-[104px]"
            />
          </div>

          <p className=" font-semibold text-[1.75rem] lg:text-[2.875rem] lg:text-start">
            {percentage4}%
          </p>
          <p className=" text-[1rem] font-normal  lg:text-[1.125rem]">
            Kết quả được đảm bảo
          </p>
        </div>
      </div>

      <div className=" relative rounded-[16px] flex-1 bg-blue-sky-gradient3 lg:justify-start w-[23.875rem] md:h-[31rem] h-[23.5rem] lg:h-[33.5rem]   ">
        <div className="relative -z-10 w-full ">
          <img
            src={teacher}
            alt="2"
            className="rounded-[16px] w-[23.875rem] object-cover h-[23.5rem] md:w-full lg:h-[33rem] "
          />
        </div>
        <div className="absolute bottom-4 left-4 text-white ">
          <p className="text-[2.25rem] font-semibold lg:text-[2.875rem]">
            200+
          </p>
          <p className="text-[1.5rem] font-semibold w-[17rem] lg:text-[2.25rem] lg:w-[27.0625rem]">
            Đội ngũ nhân sự của chúng tôi
          </p>
        </div>
      </div>
    </div>
  );
}
